import { http as marketHttp } from './http'

export const getUserTaskMarket = params => marketHttp.get('/user/taskMarket', { params })

export const acceptMarketTask = data => marketHttp.post('/user/acceptMarketTask', data)

export const getSubcontractCandidates = params => marketHttp.get('/user/subcontractCandidates', { params })

export const getPublishedTaskDispatchProgress = (taskId, params) => marketHttp.get(`/user/publishedTasks/${taskId}/dispatchProgress`, { params })

export const getAdminTaskMarket = params => marketHttp.get('/admin/market/tasks', { params })

export const approveTask = id => marketHttp.post(`/admin/market/tasks/${id}/approve`)

export const rejectTask = (id, data) => marketHttp.post(`/admin/market/tasks/${id}/reject`, data)

export const closeTask = id => marketHttp.post(`/admin/market/tasks/${id}/close`)

export const getDerasSettings = () => marketHttp.get('/admin/deras/settings')

export const saveDerasSettings = data => marketHttp.post('/admin/deras/settings', data)

export const getDerasTaskAudits = params => marketHttp.get('/admin/deras/taskAudits', { params })

export const getRevenueOverview = () => marketHttp.get('/admin/revenue/overview')

export const getRevenueList = params => marketHttp.get('/admin/revenue/list', { params })

export const getAdminOrders = params => marketHttp.get('/admin/orders', { params })

export const getAdminOrderFulfillmentLogs = id => marketHttp.get(`/admin/orders/${id}/fulfillmentLogs`)

export const getAdminSdkReports = params => marketHttp.get('/admin/sdk/reports', { params })

export const getAdminSdkAgents = params => marketHttp.get('/admin/sdk/agents', { params })

export const getAdminSdkVerifications = params => marketHttp.get('/admin/sdk/verifications', { params })

export const getAdminDerasReviews = params => marketHttp.get('/admin/deras/reviews', { params })

export const getAdminDerasReviewDetail = id => marketHttp.get(`/admin/deras/reviews/${id}`)

export const handleAdminDerasReview = (id, data) => marketHttp.post(`/admin/deras/reviews/${id}/handle`, data)

export const getAdminDispatchList = params => marketHttp.get('/admin/dispatch/list', { params })

export const getAdminDispatchTasks = params => marketHttp.get('/admin/dispatch/tasks', { params })

export const getAdminDispatchTaskDetail = taskId => marketHttp.get(`/admin/dispatch/tasks/${taskId}`)

export const retryAdminDispatch = taskId => marketHttp.post(`/admin/dispatch/tasks/${taskId}/retry`)

export const openGrabAdminDispatch = taskId => marketHttp.post(`/admin/dispatch/tasks/${taskId}/openGrab`)

export const manualAdminDispatch = (taskId, data) => marketHttp.post(`/admin/dispatch/tasks/${taskId}/manual`, data)

export const cancelAdminDispatch = (id, data) => marketHttp.post(`/admin/dispatch/${id}/cancel`, data)

export const testAdminDispatchLock = (taskId, data) => marketHttp.post(`/admin/dispatch/tasks/${taskId}/lockTest`, data)

export const getAdminOperationExceptions = params => marketHttp.get('/admin/operations/exceptions', { params })

export const pauseAdminRobotOrders = robotId => marketHttp.post(`/admin/operations/robots/${robotId}/pause`)

export const handleAdminOperationException = data => marketHttp.post('/admin/operations/exceptions/handle', data)

export const getAdminRobotMarket = params => marketHttp.get('/admin/market/robots', { params })

export const takeDownRobot = id => marketHttp.post(`/admin/market/robots/${id}/takeDown`)

export const getAdminRobotArchives = params => marketHttp.get('/admin/robot-archives', { params })

export const updateAdminRobotArchive = (id, data) => marketHttp.post(`/admin/robot-archives/${id}`, data)

export const getAdminUsers = params => marketHttp.get('/admin/users', { params })

export const updateAdminUser = (id, data) => marketHttp.post(`/admin/users/${id}/update`, data)

export const disableAdminUser = id => marketHttp.post(`/admin/users/${id}/disable`)

export const enableAdminUser = id => marketHttp.post(`/admin/users/${id}/enable`)

export const getAdminOpenApiDoc = () => marketHttp.get('/admin/openApiDoc')

export const saveAdminOpenApiDoc = data => marketHttp.post('/admin/openApiDoc/save', data)
